document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".product-tabs__item");
  tabs.forEach(tab => tab.addEventListener("click", () => {
    let blockId = tab.innerText.toLowerCase().replace(/\s/g, '-');
     
    if (tab.innerText.toLowerCase() === 'structure') {
      blockId = 'ingredients';
    }
    const targetBlock = document.getElementById(blockId);
    if (targetBlock) {
      targetBlock.scrollIntoView({ behavior: "smooth" });
    }
  }));

  const videoWraps = document.querySelectorAll('#video-wrap');
  if (videoWraps) {
    videoWraps.forEach(videoWrap => {
      const playBtn = videoWrap.querySelector('#play-pause');
      const video = videoWrap.querySelector('#video');

       if (playBtn) {
         playBtn.onclick = function () {
          if (video.paused) {
            videoWrap.classList.remove('video-block__wrap--paused')
            videoWrap.classList.add('video-block__wrap--played')
            video.play();
          } else {
            videoWrap.classList.add('video-block__wrap--paused')
            videoWrap.classList.remove('video-block__wrap--played')
            video.pause();
          }
        };
       }
    });
  }

  function isFullyRendered(element) {
    aliexpressWrapper.style.opacity = '0';
    return new Promise((resolve) => {
      let lastNonZeroHeight = 0;
      const checkInterval = setInterval(() => {
        const height = element.offsetHeight;

        if (height > 0) {
          lastNonZeroHeight = height;
        }

        setTimeout(() => {
          if (height > 0) {
            clearInterval(checkInterval);
            resolve(lastNonZeroHeight);
          }
        }, 100);
      }, 100);
    });
  }

  const aliexpressWrapper = document.getElementById("aliexpress-review-wrapper-sp");
  const reviewsBlock = document.getElementById("reviews-block");

  if (aliexpressWrapper && reviewsBlock) {
    isFullyRendered(aliexpressWrapper).then((lastNonZeroHeight) => {
      aliexpressWrapper.style.display = 'none';
      if (lastNonZeroHeight > 0) {
        aliexpressWrapper.style.display = 'none';
        reviewsBlock.style.minHeight = `${lastNonZeroHeight}px`;
        reviewsBlock.appendChild(aliexpressWrapper);
        aliexpressWrapper.style.display = 'block';
        aliexpressWrapper.style.opacity = '1';

        function handleDisplayChange(mutations) {
          mutations.forEach(mutation => {
            if (mutation.attributeName === 'style') {
              const displayValue = mutation.target.style.display;

              const closeDiv = mutation.target.nextElementSibling;

              if (displayValue === 'inline') {
                closeDiv.classList.add('show');
                closeDiv.classList.remove('hidden');
              } else {
                closeDiv.classList.remove('show');
                closeDiv.classList.add('hidden');
              }
            }
          });
        }
        function appendCloseDivToZomImages() {
          const images = document.querySelectorAll('.zom-img');

          images.forEach(img => {
            const closeDiv = document.createElement('div');
            closeDiv.classList.add('close-button');

            img.parentNode.insertBefore(closeDiv, img.nextSibling);

            const observer = new MutationObserver(handleDisplayChange);

            observer.observe(img, { attributes: true });
          });
        }

        appendCloseDivToZomImages();
      }
    });
  }

});

